import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import styled from "styled-components";
import FilterButton from "../../components/Common/FilterButton";
import Permission from "../../components/Common/Permission";
import { FlexContainer, Heading } from "../../constants/assets/containers";
import * as SubIssueTypeActions from "../../store/actions/SubIssueTypes";
import Button from "sushiweb/Button";
import { useHistory, useLocation, useParams } from "react-router-dom";
import MenuActionsMappings from "../../constants/Menu/MenuActionsMappings";
import MenuNames from "../../constants/Menu/MenuNames.json";
import SubIssueTypeList from "../../components/LogisticsSupport/SubIssueTypesList";
import ListPagination from "../../components/Common/ListPagination";
import SubIssueTypeFilterModal from "../../components/LogisticsSupport/SubIssueTypesList/SubIssueTypeFilterModal";
import * as UserActions from "../../store/actions/User";

const SubIssueType = (props) => {
  const {
    getSubIssueTypeList,
    subIssueTypeList,
    prevPage,
    nextPage,
    activeFilters,
    setSideBarCollapsed,
  } = props;
  const history = useHistory();
  const { issueId: urlIssueId } = useParams();
  const location = useLocation();
  const searchQueryParams = location.search;
  const paramsObject = new URLSearchParams(searchQueryParams);

  const issueId =
    urlIssueId ||
    (paramsObject.get("id") === null ? "" : paramsObject.get("id"));
  const [currentPage, setCurrentPage] = React.useState(1);
  const [showFilterModal, setShowFilterModal] = React.useState(false);
  const allActions = MenuActionsMappings[MenuNames.LOGISTICS_SUPPORT_DASHBOARD];

  React.useEffect(() => {
    if (issueId) {
      getSubIssueTypeList(currentPage, { issueTypeId: issueId });
    } else {
      if (subIssueTypeList.length === 0) {
        getSubIssueTypeList(currentPage, activeFilters);
      }
    }
    setSideBarCollapsed(true);
  }, []);

  const handleClick = (action) => {
    if (action === "Add") {
      history.push("/sub-issue-types/create");
    } else {
      setShowFilterModal(true);
    }
  };

  const handleModalClose = () => {
    setShowFilterModal(false);
  };

  const handleNavClick = (action) => {
    if (action === "prev") {
      getSubIssueTypeList(currentPage - 1, activeFilters);
      setCurrentPage(currentPage - 1);
    } else {
      getSubIssueTypeList(currentPage + 1, activeFilters);
      setCurrentPage(currentPage + 1);
    }
  };

  return (
    <SubIssueTypeContainter>
      <FlexContainer align="flex-start">
        <Heading>Sub Issue Types</Heading>
        <div className="actionBar mb-20 flex items-center justify-end">
          <Permission requiredPerms={[allActions.LIST_SUB_ISSUE_TYPE]}>
            <FilterButton
              activeFilters={activeFilters}
              handleClick={() => handleClick("Filter", null)}
            />
          </Permission>
          <Permission requiredPerms={[allActions.CREATE_SUB_ISSUE_TYPE]}>
            <Button
              onClick={() => handleClick("Add", null)}
              className="sushi-btn ml-12"
              data-testid="subIssueTypeCreationButton"
            >
              Add New
            </Button>
          </Permission>
        </div>
      </FlexContainer>
      <SubIssueTypeList subIssueTypeList={subIssueTypeList} />
      <ListPagination
        nextPage={nextPage}
        prevPage={prevPage}
        handleNavClick={handleNavClick}
      />
      {showFilterModal && (
        <SubIssueTypeFilterModal handleModalClose={handleModalClose} />
      )}
    </SubIssueTypeContainter>
  );
};
const SubIssueTypeContainter = styled.div``;

function mapStateToProps(state) {
  const { SubIssueTypes } = state;
  return {
    subIssueTypeList: SubIssueTypes.subIssueTypeList,
    nextPage: SubIssueTypes.nextPage,
    prevPage: SubIssueTypes.prevPage,
    activeFilters: SubIssueTypes.activeFilters,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    getSubIssueTypeList: bindActionCreators(
      SubIssueTypeActions.getSubIssueTypesList,
      dispatch
    ),
    setSideBarCollapsed: bindActionCreators(
      UserActions.setSideBarCollapsed,
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SubIssueType);
